<template>
  <div id="products">
      <section class="section">
        <div class="pageControl left" @click="prev">
            <i class="el-icon-arrow-left"></i>
        </div>
        <div class="pageControl right" @click="next">
            <i class="el-icon-arrow-right"></i>
        </div>
          <div class="fixWrap" :class="{show: showFix}">
                <div class="fixMain">
                    <div class="fixMain-i" :style="{transform: `translateX(${left})`}">
                        <div class="aProduct p-w"  v-for="meal in list" :key="meal.id">
                            <div class="aProduct-i" :class="{free: !meal.originalPrice && !meal.discountPrice}">
                                <div class="product_title">
                                    {{meal.name}}
                                </div>
                                <div class="originPrice">
                                    <span v-if="meal.originalPrice && meal.discountPrice && meal.originalPrice > meal.discountPrice">
                                        原价${{((meal.originalPrice || 0) *1).toFixed(2)}}</span>
                                </div>
                                <div class="product_price">
                                    <!-- ${{meal.price}} / {{meal.validMonth}}月 -->
                                    ${{((meal.discountPrice || meal.originalPrice || 0) *1).toFixed(2)}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
          </div>
            <div class="products_title">
                <div class="title">购买其他版本</div>
            </div>
            <div class="products_main" ref="main">
                <div class="products_main_i" ref="main_i" :style="{transform: `translateX(${left})`}">
                    <div class="aProduct p-w" v-for="meal in list" :key="meal.id">
                        <div class="aProduct-i" :class="{free: !meal.originalPrice && !meal.discountPrice}">
                            <div class="product_title">
                                {{meal.name}}
                            </div>
                            <div class="originPrice">
                                <span v-if="meal.originalPrice && meal.discountPrice && meal.originalPrice > meal.discountPrice">
                                    原价${{((meal.originalPrice || 0) *1).toFixed(2)}}</span>
                            </div>
                            <div class="product_price">
                                <!-- ${{meal.price}} / {{meal.validMonth}}月 -->
                                ${{((meal.discountPrice || meal.originalPrice || 0) *1).toFixed(2)}}
                            </div>
                            <div class="product_desc">
                                <div class="desc">好友人数{{meal.attributeData.serverPeopleNum || 0}}人</div>
                                <div class="desc">圈子数量{{meal.attributeData.circleNum || 0}}个</div>
                                <div class="desc">管理员{{meal.attributeData.adminNum || 0}}人</div>
                                <!-- <div class="desc" v-if="meal.attributeData.isKurento">支持Kurento服务</div> -->
                            </div>
                            <div class="product_button">
                                <!-- <button v-if="!meal.price">开始使用</button>
                                <button v-else @click="buyMeal(meal)">立即购买</button> -->
                                <button @click="toInstructions()" v-if="!meal.originalPrice && !meal.discountPrice">开始使用</button>
                                <button v-else @click="buyMeal(meal)">立即购买</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <template v-for="m in modules">
                <div class="modules" v-if="m.appFunctionList.length" :key="m.moduleId">
                    <div class="modules_names">
                        <div class="module_name" v-for="mm in m.appFunctionList" :key="mm.id">
                            {{mm.name}}
                        </div>
                    </div>
                    <div class="title">{{m.moduleName}}</div>
                    <div class="modules_compare">
                        <!-- <div class="aModule" v-for="(mm,index) in m.appFunctionList" :key="mm.id" 
                            :class="{includes: list[index].funCodeArr.includes(mm.functionCode)}">
                        </div> -->
                        <div class="modules_compare_i" :style="{transform: `translateX(${left})`}">
                            <div class="aMeal p-w" v-for="meal in list" :key="meal.id">
                                <div class="aMeal_i">
                                    <div class="aModule" v-for="mm in m.appFunctionList" :key="mm.id"
                                        :class="{includes: mm.funType == 1 || meal.funCodeArr.includes(mm.functionCode),
                                            new: mm.introduce && meal.funCodeArr.includes(mm.functionCode)}">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>


            <!-- <div class="products_header">
                <div class="products_title" 
                    :class="{show: showMeal.id === meal.id}" v-for="meal in list" :key="meal.id"
                    @click="getModule(meal)">
                    {{meal.name}}
                </div>
            </div>
            <div class="products_body" v-if="showMeal && showMeal.id">
                <div class="product_row">
                    <div class="product_label">套餐介绍</div>
                    <div class="product_value">{{showMeal.introduce}}</div>
                </div>
                <div class="product_row" v-for="m in showMeal.modules" :key="m.id">
                    <div class="product_label">{{m.moduleName}}</div>
                    <div class="product_value">
                        <div class="module" v-for="mm in m.children" :key="mm.id">
                            {{mm.name}} 
                            <span class="status includes" v-if="mm.funType == 1 || showMeal.funCodeArr.includes(mm.functionCode)">√</span>
                            <span class="status uncludes" v-else>×</span>
                        </div>
                    </div>
                </div>
                <div class="product_row">
                    <div class="product_label">套餐价格</div>
                    <div class="product_value">${{showMeal.price}} / 12月</div>
                </div>
                <div class="product_row">
                    <div class="product_label"></div>
                    <div class="product_value">
                            <div class="table_price_bottm" @click="buyMeal(showMeal)"> <a class="bt_main" >Buy now</a></div>
                    </div>
                </div>
            </div> -->
      </section>
      <!-- end section -->
      <!-- footer -->
  </div>
</template>
<style lang="scss">
@import "../assets/template/css/bootstrap.min.css";
@import "../assets/template/css/style.css";
@import "../assets/template/css/responsive.css";
@import "../assets/template/css/colors.css";
@import "../assets/template/css/animate.css";
#products{
    background-image: url("../assets/img2/products_bg1.png"),url("../assets/img2/products_bg2.png");
    background-position: left 8%,right 35%;
    background-repeat: no-repeat,no-repeat;
    background-size: 30%,30%;
    .p-w{
        width:calc(100% / 3);
    }
    .pageControl{
        &:hover{
            opacity: 1;
        }
        opacity: 0.8;
        cursor: pointer;
        position:fixed;
        width:120px;
        left:30px;top:50%;
        display:flex;
        justify-content: center;
        align-items: center;
        height:61px;
        width:61px;
        z-index: 199;
        background: #DDDDDD;
        border-radius: 100%;
        color:#fff;
        font-size: 35px;
        &.right{
            left:unset;
            right:30px;
        }
    }
    .products_title{
        text-align: center;
        margin-top:2%;
        margin-bottom:3%;
        .title{
            display:inline-block;
            line-height:41px;
            background: url("../assets/img2/products_title.png") no-repeat left center;
            padding-left:40px;
            font-size: 24px;
            font-weight: bold;
        }
    }
    .fixWrap{
        position:fixed;
        width:100%;
        top: 0;left: 0;
        z-index: 199;
        transition: all 0.5s;
        transform:translateY(-199px);
        opacity: 0;
        &.show{
            transform:translateY(0px);
            opacity: 1;
        }
    }
    .fixMain{
        position: relative;
        width:calc(100vw - 240px);
        max-width: 800px;
        min-width: 240px;
        margin:0 auto;
        overflow:hidden;
        .fixMain-i{
            width:100%;
            white-space: nowrap;
            &:after{
                content:' ';
                display:block;
                clear: both;
            }
            .aProduct{
                // width:calc(100% / 3);
                // float:left;
                display:inline-block;
                overflow:hidden;
                padding:0 10px;
                .aProduct-i{
                    &.free{
                        background: #FFFFFF;
                        border-radius: 6px;
                        border: 1px solid #979797;
                    }
                    &:hover{
                        border-color: #3FB8A4;
                        background: #3FB8A4;
                        border-radius: 6px;
                        color:#fff;
                        .product_title{
                            color:#fff;
                        }
                        .originPrice{
                            color:#fff;
                        }
                        .product_price{
                            color:#fff;
                            border-color:#fff;
                        }
                        .product_desc{
                            .desc{color:#fff}
                        }
                        .product_button{
                            button{
                                background: #fff;
                                color: #3FB8A4;
                            }
                        }
                    }
                    // background: rgba(63, 184, 164, 0.07);
                    background: #F1FAF8;
                    border-radius: 6px;
                    border: 3px solid #3FB8A4;
                    .product_title{
                        font-size:24px;
                        font-weight: bold;
                        // line-height:41px;
                        color:#333;
                        margin-top:9%;
                        text-align: center;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        transition: all 0.5s;
                        height: 32px;
                        line-height: 32px;
                    }
                    .originPrice{
                        text-align: center;
                        line-height: 25px;
                        margin-top: 5%;
                        margin-bottom: 3%;
                        font-size: 12px;
                        color: #999999;
                        text-decoration: line-through;
                        transition: none;
                        height:24px;
                    }
                    .product_price{
                        font-size:30px;
                        font-weight: bold;
                        // line-height:41px;
                        text-align: center;
                        color:#3FB8A4;
                        padding-bottom: 11%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        transition: all 0.5s;
                    }
                    .product_desc{
                        display:flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        height:300px;
                        overflow-y: auto;
                        .desc{
                            color:#333;
                            margin:5px 0;
                            transition: all 0.5s;
                            line-height: 30px;
                        }
                    }
                    .product_button{
                        text-align: center;
                        margin-bottom:20px;
                        button{
                            width: 171px;
                            height: 56px;
                            background: #3FB8A4;
                            color:#fff;
                            font-size:22px;
                            line-height:56px;
                            text-align: center;
                            border:none;
                            outline: none;
                            border-radius: 3px;
                            &:active{
                                background:#dedddd;
                            }
                        }
                    }
                }
            }
        }
    }
    .products_main{
        position: relative;
        width:calc(100vw - 240px);
        max-width: 800px;
        min-width: 240px;
        margin:0 auto;
        overflow:hidden;
        .products_main_i{
            width:100%;
            white-space: nowrap;
            &:after{
                content:' ';
                display:block;
                clear: both;
            }
            .aProduct{
                // width:calc(100% / 3);
                // float:left;
                display:inline-block;
                overflow:hidden;
                padding:0 10px;
                .aProduct-i{
                    &.free{
                        background: #FFFFFF;
                        border-radius: 6px;
                        border: 1px solid #979797;
                    }
                    &:hover{
                        border-color: #3FB8A4;
                        background: #3FB8A4;
                        border-radius: 6px;
                        color:#fff;
                        .product_title{
                            color:#fff;
                        }
                        .originPrice{
                            color:#fff;
                        }
                        .product_price{
                            color:#fff;
                            border-color:#fff;
                        }
                        .product_desc{
                            .desc{color:#fff}
                        }
                        .product_button{
                            button{
                                background: #fff;
                                color: #3FB8A4;
                            }
                        }
                    }
                    // background: rgba(63, 184, 164, 0.07);
                    background: #F1FAF8;
                    border-radius: 6px;
                    border: 3px solid #3FB8A4;
                    .product_title{
                        font-size:24px;
                        font-weight: bold;
                        // line-height:41px;
                        color:#333;
                        margin-top:9%;
                        text-align: center;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        transition: all 0.5s;
                        height: 32px;
                        line-height: 32px;
                    }
                    .originPrice{
                        text-align: center;
                        line-height: 25px;
                        margin-top: 5%;
                        margin-bottom: 3%;
                        font-size: 12px;
                        color: #999999;
                        text-decoration: line-through;
                        height:24px;
                        transition: none;
                    }
                    .product_price{
                        font-size:30px;
                        font-weight: bold;
                        // line-height:41px;
                        text-align: center;
                        color:#3FB8A4;
                        border-bottom:1px solid #979797;
                        padding-bottom: 11%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        transition: all 0.5s;
                    }
                    .product_desc{
                        display:flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        height:300px;
                        overflow-y: auto;
                        .desc{
                            color:#333;
                            margin:5px 0;
                            transition: all 0.5s;
                            line-height: 30px;
                        }
                    }
                    .product_button{
                        text-align: center;
                        margin-bottom:20px;
                        button{
                            width: 171px;
                            height: 56px;
                            background: #3FB8A4;
                            color:#fff;
                            font-size:22px;
                            line-height:56px;
                            text-align: center;
                            border:none;
                            outline: none;
                            border-radius: 3px;
                            &:active{
                                background:#dedddd;
                            }
                        }
                    }
                }
            }
        }
    }
    .modules{
        position: relative;
        width:calc(100vw - 240px);
        max-width: 800px;
        min-width: 240px;
        margin:0 auto;
        // overflow:hidden;
        .modules_names{
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow:hidden;
            width:120px;
            position:absolute;
            left:-120px;
            top:67px;
            background: #EEEEEE;
            border-radius: 2px;
            z-index: 99;
            padding:4px 0;
            .module_name{
                height:30px;
                line-height:30px;
                text-align: center;
            }
        }
        .title{
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            padding-top: 25px;
            padding-bottom: 10px;
            height:67px;
        }
        .modules_compare{
            width:100%; 
            white-space: nowrap;
            overflow: hidden;
            .modules_compare_i{
                width:100%;
                &:after{
                    content:' ';
                    display:block;
                    clear: both;
                }
            }
            .aMeal{
                // width:calc(100% / 3);
                // float:left;
                display:inline-block;
                overflow:hidden;
                padding:0 10px;
                .aMeal_i{
                    background: #EEEEEE;
                    border-radius: 2px;
                    padding:4px 0;
                    .aModule{
                        // text-align: center;
                        height:30px;
                        background:url("../assets/img2/uncontain.png") no-repeat center center;
                        background-size:18px;
                        &.includes{
                            background:url("../assets/img2/contain.png") no-repeat center center;
                            background-size:18px;
                        }
                        position:relative;
                        &.new{
                            background:none;
                            &:before{
                                content:'即将上线';
                                display:block;
                                line-height:30px;
                                text-align: center;
                                font-size:12px;
                            }
                        }
                    }
                }
            }
        }
    }
}
@media screen and (max-width: 800px){
    #products{
        .p-w{
            width:50%;
        }
    }
}
@media screen and (max-width: 600px){
    #products{
        .p-w{
            width:100%;
        }
        .modules{
            .modules_names{
                box-shadow: 0 0 15px rgba(0,0,0,0.1);
                left: -50px;
                width: 100px;
            }
        }
    }
}
@media screen and (min-width: 900px){
    #products{
        .pageControl{
            left:10%;
            &.right{
                left:unset;
                right:10%;
            }
        }
    }
}
@media screen and (min-width: 1300px){
    #products{
        .pageControl{
            left:15%;
            &.right{
                left:unset;
                right:15%;
            }
        }
    }
}
</style>

<script>
import server from "@/public/service"
import {SUCCESS_CODE} from "@/public/state";
import getInterfaceData from "@/public/service/getInterfaceData";
export default {
  title: "Dingo Group",	
  data() {
    return {
        list: [],
        showMeal: {},
        modules: [],
        showFix: false,
        left: "0",
        leftNum: 0
    };
  },
  methods: {
    getMeal(){
        var params = {
            current:1,
            size:999,
            shelvesState: 1
        };
        server.getMeal(params).then(data=>{
            if(data.reCode === SUCCESS_CODE){
                var result = getInterfaceData(data);
                this.list = result.records.sort((a,b)=>a.discountPrice-b.discountPrice).map(v=>{
                    v.shelvesState = (v.shelvesState === 1);
                    v.attributeData = {};
                    try{
                        v.funCodeArr = JSON.parse(v.funCode).fun_code.split(",");
                        v.attributeData = JSON.parse(v.attribute);
                    }catch(e){
                        v.funCodeArr = [];
                        v.attributeData = {};
                    };
                    return v;
                })
                console.log("getMeal",this.list)
            };
        });
    },
    getModule(meal){
        if(meal && meal.modules){
            this.showMeal = meal;
        }else{
            server.getModule().then(data=>{
                if(data.reCode === SUCCESS_CODE){
                    var result = getInterfaceData(data);
                    Promise.all(result.map(v=>{
                        return server.getService({
                            moduleId: v.id,
                            size:999,
                            current:1
                        })
                    })).then(_data=>{
                        meal.modules = [];
                        _data.forEach((vv,i)=>{
                            if(vv.reCode === SUCCESS_CODE){
                                var _result = getInterfaceData(vv);
                                meal.modules.push({
                                    moduleName: result[i].moduleName,
                                    id: result[i].id,
                                    children: _result.records.map(v=>{
                                        return v;
                                    })
                                });
                            }
                        })
                        this.showMeal = meal;
                        console.log("getModule",this.showMeal)
                    })
                };
            });
        };
    },
    getAllModules(){
        server.getAllModules().then(data=>{
            if(data.reCode === SUCCESS_CODE){
                var result = getInterfaceData(data);
                this.modules = result;
            };
        });
    },
    buyMeal(meal){
        this.$store.state.orderDetail = JSON.parse(JSON.stringify(meal));
        this.$router.push({
            path: "/orderDetail",
        });
    },
    scroll(e){
        // console.log("scroll",e)
        var main = this.$refs.main;
        var html = document.getElementsByTagName("html")[0];
        if(main && html.scrollTop >= (main.offsetTop + main.offsetHeight - 200)){
            this.showFix = true;
        }else{
            this.showFix = false;
        }
    },
    resize(e){
        setTimeout(()=>{
            var main = this.$refs['main_i'];
            if(!main) return;
            var scrollWidth = main.scrollWidth;
            var offsetWidth = main.offsetWidth;
            console.log("resize",this.leftNum,scrollWidth / offsetWidth)
            if(this.leftNum > scrollWidth / offsetWidth){
                this.leftNum = (scrollWidth / offsetWidth).toFixed(0)*1;
                this.left = `-${this.leftNum*100}%`;
            }
        },500)
    },
    next(){
        var main = this.$refs['main_i'];
        if(!main) return;
        var scrollWidth = main.scrollWidth;
        var offsetWidth = main.offsetWidth;
        if(this.leftNum + 1 < scrollWidth / offsetWidth){
            this.leftNum += 1;
            this.left = `-${this.leftNum*100}%`;
        }
    },
    prev(){
        var main = this.$refs['main_i'];
        if(!main) return;
        var scrollWidth = main.scrollWidth;
        var offsetWidth = main.offsetWidth;
        if(this.leftNum > 0 && this.leftNum - 1 < scrollWidth / offsetWidth){
            this.leftNum -= 1;
            this.left = `-${this.leftNum*100}%`;
        }
    },
    toInstructions(){
        this.$router.push("/instructions")
    }
  },
  created(){
      this.getMeal();
      this.getAllModules();
      document.addEventListener("scroll", this.scroll)
      window.addEventListener("resize", this.resize)
  },
  destroyed(){
    document.removeEventListener("scroll", this.scroll)
    window.removeEventListener("resize", this.resize)
  }
};
</script>
